export type BenchlingNodeStatus =
  | 'pending'
  | 'in-progress'
  | 'success'
  | 'completed-with-errors'
  | 'warning'
  | 'error'
  | 'ai-proposed'
  | 'halted';

export const STATUS_COLORS: Record<BenchlingNodeStatus | 'default', {color: string; colorIndex: number}> = {
  default: {color: 'gray', colorIndex: 6},
  error: {color: 'red', colorIndex: 8},
  'in-progress': {color: 'teal', colorIndex: 8},
  pending: {color: 'gray', colorIndex: 6},
  success: {color: 'green', colorIndex: 9},
  'completed-with-errors': {color: 'green', colorIndex: 9},
  warning: {color: 'orange', colorIndex: 8},
  'ai-proposed': {color: 'purple', colorIndex: 8},
  halted: {color: 'gray', colorIndex: 6},
};

// Icon color for the right-hand status icon. Usually matches STATUS_COLORS, but
// 'completed-with-errors' keeps a green node while calling out the icon in orange.
export const STATUS_ICON_COLORS: Record<
  BenchlingNodeStatus | 'default',
  {color: string; colorIndex: number}
> = {
  ...STATUS_COLORS,
  'completed-with-errors': {color: 'orange', colorIndex: 5},
};

export const DEFAULT_STATUS_BORDERS: Record<BenchlingNodeStatus | 'default', 'dashed' | 'solid'> = {
  default: 'solid',
  error: 'solid',
  'in-progress': 'solid',
  pending: 'solid',
  success: 'solid',
  'completed-with-errors': 'solid',
  warning: 'solid',
  'ai-proposed': 'dashed',
  halted: 'solid',
};

export type SectionRowStatus = 'error' | 'warning';
export type EdgeStatus = 'error' | 'warning';
